import { Get } from "@/ai_studio/http/http.js";

const ModelsResolver = async (to, from, next) => {
  try {
    const response = await Get("getAppsList");
    to.meta['apps'] = response || [];
  } catch (error) {
    console.error(error);
    to.meta['apps'] = [];
  }
  next();
}
export default ModelsResolver;
